import { MissionPage, MissionQuery } from '@edwin-group/cj-graphql';
import { create } from 'zustand';

interface MissionDetailingState {
  missionPage: MissionPage | null;
  setMissionPage: (missionResult: MissionQuery) => void;
}

export const useMissionDetailingStore = create<MissionDetailingState>((set) => ({
  missionPage: null,
  setMissionPage: (missionResult: MissionQuery) => {
    set({
      missionPage: missionResult?.missionPage as MissionPage,
    });
  },
}));
